import React from 'react';
import {Button, Col} from "antd";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const DG_Cancel = props => {

    const {t} = useTranslation();
    let navigate = useNavigate();

    const handleOnCancel = (value) => {

        navigate(-1)
    }

    return (
        <Col className={"ml-3"}>
            <Button onClick={handleOnCancel} key="button_cancel" style={{fontWeight: 600, fontSize: '14px'}}>
                {t("common.back")}
            </Button>
        </Col>
    );
};

DG_Cancel.propTypes = {};

export default DG_Cancel;